<template>
  <div class="alert rounded p-4 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-start">
      <div class="alert-icon me-3">
        <i class="fas fa-exclamation-triangle text-danger"></i>
      </div>
      <div>
        <h5 class="mb-2 fw-bold">Verification Rejected</h5>
        <small>We are sorry your submission is rejected, please re-submit the verification process</small>
        <p class="mb-0"><strong>Reasons : </strong> {{ reason }}</p>
      </div>
    </div>
    <div>
      <argon-button class="btn btn-success" @click="$router.push('/company-detail')">Re-submit</argon-button>
    </div>
  </div>
</template>

<script>
import ArgonButton from '@/components/ArgonButton.vue'

export default {
  name: 'VerificationRejectedAlert',
  components: {
    ArgonButton
  },
  props: {
    reason: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.alert {
  background-color: #fbeaea;
  border: 1px solid #f8443a;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.alert-icon {
  color: #f8443a;
  font-size: 1.5rem;
}

.btn-success {
  background-color: #63b47a;
  border-color: #63b47a;
  padding: 8px 16px;
}
</style>